import React from "react";
import { Box, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useScreenshotTranslation } from "../../../lib/screenshotI18n";
import { MAIN_PATH } from "../routes";
import { formatScreenshotAccessValidThroughLabel } from "../lib/screenshotAccess";
import { jigsawMobileAccent, phoneShellSx, promoNavy } from "../styles/mainStyles";

export default function ScreenshotExpiredPage() {
    const { t } = useScreenshotTranslation();
    const validThrough = formatScreenshotAccessValidThroughLabel();

    return (
        <Box
            sx={{
                ...phoneShellSx,
                alignItems: "center",
                justifyContent: "center",
                px: 3,
                py: 6,
                textAlign: "center",
            }}
        >
            <Typography
                component="h1"
                sx={{
                    fontWeight: 800,
                    fontSize: { xs: "1.5rem", sm: "1.75rem" },
                    color: promoNavy,
                    mb: 1.5,
                }}
            >
                {t("mobileScreenshot.common.page-expired-title")}
            </Typography>
            <Typography sx={{ color: "text.secondary", maxWidth: 360, mb: 2 }}>
                {t("mobileScreenshot.common.page-expired-body", { date: validThrough })}
            </Typography>
            <Link component={RouterLink} to={MAIN_PATH} sx={{ color: jigsawMobileAccent, fontWeight: 600 }}>
                {t("mobileScreenshot.common.back-to-screenshot-index")}
            </Link>
        </Box>
    );
}
